"use client";

import { FileUser } from "lucide-react";

import { TenantLogo } from "@/components/tenant-logo";
import { tenantLogoFor } from "@/config/tenant-assets";
import type { TenantIdentity } from "@/config/tenants";
import { useAppLocale } from "@/features/localization/app-locale-provider";

interface AuthBrandProps {
  tenant: TenantIdentity;
}

export function AuthBrand({ tenant }: Readonly<AuthBrandProps>) {
  const { locale } = useAppLocale();
  const hasLogo = tenantLogoFor(tenant.code, locale) !== null;

  return (
    <div
      aria-label={`${tenant.displayName} CV Builder`}
      className={hasLogo ? "flex justify-center" : "flex items-center gap-4"}
    >
      {hasLogo ? (
        <TenantLogo
          className="size-48 rounded-2xl object-cover shadow-sm ring-1 ring-primary-foreground/30 sm:size-56"
          locale={locale}
          priority
          tenant={tenant.code}
        />
      ) : (
        <>
          <span
            aria-hidden="true"
            className="flex size-13 shrink-0 items-center justify-center rounded-xl bg-[var(--tenant-structure-foreground,var(--primary-foreground))] text-[var(--tenant-structure,var(--primary))] shadow-sm ring-1 ring-primary-foreground/30 sm:size-14"
          >
            <FileUser className="size-6 sm:size-7" strokeWidth={2.25} />
          </span>
          <span className="text-2xl font-bold tracking-tight text-[var(--tenant-structure-foreground,var(--primary-foreground))] 2xl:text-[28px]">
            {tenant.displayName}
          </span>
        </>
      )}
    </div>
  );
}
